<template>
  <div>
    <div class="box" id="box" ref="box">
      <div class="title-box">
        <div class="title-logo"></div>
        <div class="title-txt">新增漏洞列表</div>

        <div class="list-fir">
          <div class="list-box">
            <div class="list-data">
              <div class="list-data-title">
                <td>数据来源</td>
                <td>漏洞数</td>
                <td>更新时间</td>
                <div class="list-data-title-bor"></div>
                <div class="list-data-title-bor-sed"></div>
              </div>

              <div class="data-list-container">
                <div class="data-list-column" v-for="item in bugList" @click="openDialog">
                  <td class="td-column td-border">{{item.value1}}</td>
                  <td class="td-column">{{item.value2}}</td>
                  <td class="td-column td-border-last">{{item.value3}}</td>
                  <div class="list-data-title-bor-column"></div>
                  <div class="list-data-title-bor-sed-column"></div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>

export default {
  data() {
    return {
      bugList: [
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"},
        {value1: "高危!PHP CGIWindows平台远程代码执行漏洞", value2: "漏洞数", value3: "2024-06-30"}
      ]
    };
  },
  mounted() {
  },
  methods: {
    openDialog() {
      this.$emit("openDialog");
    }
  }
};


</script>
<style scoped  lang="less">
.box {
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 430px;
  height: 620px;
  border-radius: 10px;
  position: relative;
}
.title-box {
  .title-logo {
    background-image: url("../../assets/img/新增漏洞列表logo.png");
    background-repeat: no-repeat;
    background-size: 100%;
    height: 53px;
    width: 59px;
    position: absolute;
    left: 20px;
    top: 15px;
  }
  .title-txt {
    background-image: url("../../assets/img/ask_bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
    color: rgba(241, 237, 255, 1);
    font-family: 'YouSheBiaoTiHei';
    font-size: 24px;
    height: 54px;
    width: 260px;
    line-height: 54px;
    position: absolute;
    left: 79px;
    top: 15px;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1);
    text-align: left;
    padding-left: 20px;
  }
}
.warp {
  position: absolute;
  left: 18px;
  top: 58px;
  height: 335px;
  font-family: AlibabaRegular;
  overflow: hidden;
}
.list-fir {
  display: flex;
  position: relative;
  top: 70px;
}
.list-box {
  width: 330px;
  height: 235px;
  margin: 10px auto;
}
.list-data {
  .list-data-title {
    background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
    height: 36px;
    line-height: 36px;
    width: 392px;
    margin: 0 auto;
    position: relative;
    top: 10px;
    left: -30px;
    font-size: 14px;
    color: white;
    text-align: center;

    border: 1px solid #7678ae;
  }
}

.list-data-title::before,
.list-data-title::after {
  content: '';
  position: absolute;
  width: 6px; /* 正方形边长 */
  height: 4px;
  background-color: #aaadeb; /* 正方形颜色 */
}

/* 左上角和右上角 */
.list-data-title::before {
  top: -1px;
  left: -1px; /* 左上角位置 */
  box-shadow: 387px 0 0 0 #aaadeb; /* 用box-shadow制作右上角 */
}

/* 左下角和右下角 */
.list-data-title::after {
  bottom: -1px;
  left: -1px; /* 左下角位置 */
  box-shadow: 387px 0 0 0 #aaadeb;
}

.list-data-title-bor {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 130px;
}
.list-data-title-bor-column {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 130px;
}

.list-data-title-bor-sed-column {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 260px;
}

.list-data-title-bor-sed {
  position: absolute;
  width: 1px;
  height: 30px;
  border-left: 2px solid transparent;
  border-image: linear-gradient(to bottom, rgba(159, 158, 242, 0) 0%, #9F9EF2 50%, rgba(159, 158, 242, 0) 100%) 1;
  top: 3px;
  left: 260px;
}
td {
  width: 130px;
  font-weight: bold;
}

.data-list-container {
  cursor: pointer;
  position: relative;
  height: 470px;
  top: 15px;
  left: -48px;
  width: 396px;
  margin: 0 0 0 18px;
  overflow-y: auto;
  box-sizing: content-box; /* 让padding不影响内容宽度 */
  scrollbar-width: thin; /* 适用于 Firefox，设置滚动条为细长 */
  scrollbar-color: #757ebe transparent; /* 滚动条颜色和背景 */
  border-left: 1px solid #424362;
  .data-list-column {
    height: 33px;
    position: relative;
    .td-column {
      position: relative;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      color: #FFF;
      font-weight: bold;
      border-bottom: 0.5px solid #424362;
      border-top: 0.5px solid #424362;
    }
    .td-border {
      max-width: 130px; /* 设置最大宽度 */
      white-space: nowrap; /* 禁止换行 */
      overflow: hidden; /* 隐藏超出部分 */
      text-overflow: ellipsis; /* 显示省略号 */
    }

    .td-border::before {
      top: 3px;
      left: -1px; /* 左上角位置 */
      box-shadow: 380px 0 0 0 #aaadeb; /* 用box-shadow制作右上角 */
    }
    .td-border::before {
      content: '';
      position: absolute;
      width: 4px; /* 正方形边长 */
      height: 4px;
      background-color: #aaadeb; /* 正方形颜色 */
    }
    .td-border::before {
      top: 29px;
      left: -1px; /* 左上角位置 */
    }
    //background-color: #00F0FF;
  }
}

/* 适用于 Webkit 内核（如 Chrome 和 Edge） */
.data-list-container::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
  height: 8px; /* 横向滚动条高度 */
}

.data-list-container::-webkit-scrollbar-thumb {
  background-color: #757ebe; /* 滚动条的颜色 */
  border-radius: 4px; /* 让滚动条块稍微圆角 */
}

.data-list-container::-webkit-scrollbar-track {
  background-color: transparent; /* 滚动条背景透明 */
}

.td-border-last {
  border-right: 1px solid #424362;
}

.data-list-column:hover {
  background: linear-gradient(to right, #9F9EF2 0%, #9F9EF2 0%, transparent 90%);
}

</style>
